import {
  Box,
  SxProps,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  Typography,
} from '@mui/material';
import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material';
import { ColumnAlignment, Row, TableInstance, TableRowProps } from 'react-table';
import { IAdditionalQuoteDocumentationItem } from 'shared/types';

const containerStyles: SxProps<Theme> = {
  maxHeight: '173px',
  minHeight: '173px',
};

const cellStyles: SxProps = {
  padding: {
    xs: '5px',
    sm: '6px 16px',
  },
  fontSize: {
    xs: '12px',
    sm: '14px',
  },
};
const getHeaderFlexAlignment = (align: ColumnAlignment) => {
  switch (align) {
    case 'center':
      return 'center';
    case 'right':
      return 'flex-end';
    default:
      return 'flex-start';
  }
};

interface AdditionalQuoteDocumentationTableProps {
  instance: TableInstance<IAdditionalQuoteDocumentationItem>;
}

export function AdditionalQuoteDocumentationTable({ instance }: AdditionalQuoteDocumentationTableProps) {
  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, page } = instance;

  const headers = headerGroups.map(headerGroup => (
    <TableRow {...headerGroup.getHeaderGroupProps()}>
      {headerGroup.headers.map(column => (
        <TableCell
          align={column.align}
          sx={cellStyles}
          {...column.getHeaderProps({
            style: {
              width: column.width,
            },
          })}
        >
          <Box
            component='span'
            {...column.getSortByToggleProps({ style: { justifyContent: getHeaderFlexAlignment(column.align) } })}
          >
            {column.render('Header')}
            {column.isSorted ? column.isSortedDesc ? <ArrowDropDown /> : <ArrowDropUp /> : null}
          </Box>
        </TableCell>
      ))}
    </TableRow>
  ));
  const rows = page.length
    ? page.map((row, i) => {
        prepareRow(row);
        const { key, ...rest } = row.getRowProps();
        return <AdditionalQuoteDocumentationTableRow key={key} row={row} {...rest} />;
      })
    : [
        <TableRow key='no-data'>
          <TableCell colSpan={6} sx={cellStyles}>
            <Typography>No documents have been uploaded.</Typography>
          </TableCell>
        </TableRow>,
      ];
  return (
    <div>
      <TableContainer sx={containerStyles}>
        <Table size='small' stickyHeader {...getTableProps()}>
          <TableHead>{headers}</TableHead>
          <TableBody {...getTableBodyProps()}>{rows}</TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

interface AdditionalQuoteDocumentationTableRowProps extends TableRowProps {
  row: Row<IAdditionalQuoteDocumentationItem>;
}

function AdditionalQuoteDocumentationTableRow({ row, ...props }: AdditionalQuoteDocumentationTableRowProps) {
  return (
    <TableRow {...props}>
      {row.cells.map(cell => (
        <TableCell sx={cellStyles} align={cell.column.align} {...cell.getCellProps()}>
          {cell.render('Cell')}
        </TableCell>
      ))}
    </TableRow>
  );
}
